import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { VBox } from "@ui/box/Box";
import { Rows } from "@ui/table/Rows";
import { TitledValue } from "@ui/table/TitledValue";
import { useMemo } from "react";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { S_ADD_GROUP_POPUP } from "src/view/popup/AddGroupPopup";

interface IMerchantsListProps {
	channel_id?: number;
	acquirer_id?: number;
}

export const MerchantsList = ({ channel_id, acquirer_id }: IMerchantsListProps) => {
	 useLocale();
	const router = useRouter();
	const requestParams = useMemo(() => {
		return {
			method: "acquirers/merchants/list",
			data: {
				...(acquirer_id && { acquirer_id }),
				...(channel_id && { channel_id }),
			},
		};
	}, [acquirer_id, channel_id]);

	const [clientsList, , , isFetching] = GD.REQ_API.useRequest(undefined, {
		...requestParams,
	});

	// const onAdd = async () => {
	// 		S_ADD_CHANNEL_POPUP.invoke({
	// 			merchantID: merchantId,
	// 			onSuccess: () => {
	// 				GD.B_MERCHANT_ATTACHED_CHANNELS.execute({
	// 					merchantID: merchantId,
	// 				});
	// 			},
	// 		});
	// 	};

	return (
		<VBox gap="10px">
			{/* <HBox>
					<Spacer grow />
					<Button onClick={onAdd} title="Add Channel" variant="primarySmall" />
				</HBox> */}
			<Rows
				itemType="merchant"
				order={["__itemType", "name", "risk", "id", "domain", "description"]}
				busy={isFetching}
				data={clientsList?.data}
				error={clientsList?.error}
				cellFactory={(_row, cell, _index: number, _key, _name, sx) => {
					if (_name === "domain") {
						return {
							content: (
								<div className="clickable-cell" onClick={() => window.open(`https://${cell}`, "_blank")}>
									<TitledValue title={_name ?? "--"} value={cell ?? "--"} />
								</div>
							),
						};
					}
					if (sx) {
						sx.cursor = "default";
					}

					return { content: cell };
				}}
				onClick={(row: any) => {
					router.navigate("merchant", {
						mid: row.id + "",
						cid: row.client_id + "",
					});
				}}
				menu={[
					{
						title: (row: IClientGroup) => (row.id !== 0 ? msg("view") : null),
						id: (row: IClientGroup) => (row.id !== 0 ? "view" : null),
					},
					{
						title: (row: IClientGroup) => (row.id !== 0 ? msg("edit") : null),
						id: (row: IClientGroup) => (row.id !== 0 ? "edit" : null),
					},
					{
						title: (row: IClientGroup) => (row.id !== 0 ? msg("addChannel_62f66a6a") : null),
						id: (row: IClientGroup) => (row.id !== 0 ? "add_merchant" : null),
					},
				]}
				onMenuClick={(id, row) => {
					if (id === "edit") {
						S_ADD_GROUP_POPUP.invoke({
							groupID: row.id,
							clientID: row.client_id,
							onChange: async () => {
								await GD.REQ_API.request({
									method: "merchants/list",
									data: { client_id: row.client_id, group_id: row.id },
								});
							},
						});
						return;
					}
					if (id === "view") {
						router.navigate("merchant", {
							mid: row.id + "",
							cid: row.client_id + "",
						});
						return;
					}
				}}
			/>
		</VBox>
	);
};
